import { CONSTANT, type PosthogEvent } from '@salescore/client-base'
import { Badge, Button } from 'antd'
import type { ReactElement } from 'react'

export interface PanelOption {
  value: string
  label: string
  icon: ReactElement
  disabled: boolean
  posthogEventName?: PosthogEvent
  showIndicator?: boolean
}

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function VerticalPanelPicker<T extends PanelOption>({
  options,
  selectedValue,
  body,
  hidePanel,
  onClick,
}: {
  options: T[]
  selectedValue: T['value'] | undefined
  body: ReactElement
  hidePanel?: boolean
  onClick: (option: T) => void
}): ReactElement {
  return (
    // eslint-disable-next-line better-tailwindcss/no-unknown-classes -- no-scrollbar は main.less にスタイル定義あり
    <div className="no-scrollbar flex size-full overflow-y-scroll">
      {hidePanel !== true && (
        <div
          style={{
            borderRight: '1px solid #ddd',
          }}
          // eslint-disable-next-line better-tailwindcss/no-unknown-classes -- no-scrollbar は main.less にスタイル定義あり
          className="no-scrollbar flex flex-col overflow-y-scroll bg-white p-3"
        >
          {options.map((option, index) => (
            <Panel
              key={index}
              isPicked={option.value === selectedValue}
              option={option}
              index={index}
              onClick={() => {
                onClick(option)
              }}
            />
          ))}
        </div>
      )}
      <div className="h-full" style={{ width: hidePanel === true ? '100%' : 'calc(100% - 95px)' }}>
        {body}
      </div>
    </div>
  )
}

// eslint-disable-next-line sonarjs/prefer-read-only-props
function Panel({
  option,
  isPicked,
  index,
  onClick,
}: {
  isPicked: boolean
  onClick: () => void
  option: PanelOption
  index: number
}): ReactElement {
  return (
    <Badge
      dot={option.showIndicator === true}
      status="warning"
      offset={[-2, 2]}
      styles={{ indicator: { width: 10, height: 10, zIndex: 10 } }}
    >
      <Button
        className={`mb-3 flex flex-col items-center justify-center text-center align-middle ${
          isPicked ? 'shadow-md shadow-blue-400' : 'shadow-sm'
        }`}
        style={{
          lineHeight: 1.4,
          fontSize: 10,
          width: 70,
          height: 70,
          color: isPicked ? CONSTANT.colors.primaryColor : undefined,
          borderColor: isPicked ? CONSTANT.colors.primaryColor : undefined,
          borderWidth: isPicked ? 2 : 1,
          // backgroundColor: isPicked ? 'white' : '#ccc',
          opacity: isPicked ? 1 : 0.7,
          zIndex: index,
        }}
        onClick={onClick}
        disabled={option.disabled}
      >
        <div>
          <div className="" style={{ fontSize: 30 }}>
            {option.icon}
          </div>
          <div className="mb-2">{option.label}</div>
        </div>
      </Button>
    </Badge>
  )
}
